import { Bell, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { useSoftAsk } from '@/lib/push/use-soft-ask'
import { usePushPermission } from '@/lib/push/use-push-permission'
import { registerServiceWorker } from '@/lib/push/register-sw'
import { registerPushSubscription } from '@/lib/push/subscribe'
import { toast } from 'sonner'

export function SoftAskBanner() {
  const { visible, dismiss, hide } = useSoftAsk()
  const { requestPermission } = usePushPermission()

  if (!visible) return null

  async function handleEnable() {
    const result = await requestPermission()
    if (result === 'granted') {
      hide()
      toast.success('Notifications enabled')
      const registration = await registerServiceWorker()
      if (registration) {
        await registerPushSubscription(registration).catch(() => {
          toast.error('Failed to enable notifications. Please try again.')
        })
      }
    } else {
      hide()
      toast.error('Notifications blocked in browser settings')
    }
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 w-full max-w-[420px]">
      <Card className="shadow-lg">
        <CardContent className="p-4">
          <div className="flex items-start gap-3">
            <Bell className="size-5 text-primary mt-0.5 shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground">Stay in the loop</p>
              <p className="text-sm text-muted-foreground mt-0.5">
                Get notified when your executions finish and drafts are ready for review.
              </p>
            </div>
            <Button
              variant="ghost"
              size="icon"
              className="size-7 shrink-0 -mt-1 -mr-1"
              onClick={dismiss}
              aria-label="Dismiss"
            >
              <X className="size-4" />
            </Button>
          </div>
          <div className="mt-3 flex justify-end">
            <Button size="sm" onClick={handleEnable}>
              Enable Notifications
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
